import React from "react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("App error caught:", error);
    if (!sessionStorage.getItem("af_auto_reloaded")) {
      sessionStorage.setItem("af_auto_reloaded", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="error-fallback"
          style={{
            minHeight: "100vh", display: "flex", flexDirection: "column",
            alignItems: "center", justifyContent: "center", gap: 16,
            fontFamily: "Manrope, sans-serif", background: "#F3F4F6",
            color: "#242424", padding: 24, textAlign: "center",
          }}
        >
          <p style={{ fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>
            AD MOTORS
          </p>
          <p style={{ color: "#666", fontSize: 14 }}>
            Es ist ein unerwarteter Fehler aufgetreten.
          </p>
          <button
            data-testid="error-reload-btn"
            onClick={() => {
              sessionStorage.removeItem("af_auto_reloaded");
              window.location.reload();
            }}
            style={{
              background: "#242424", color: "#fff", border: "none",
              borderRadius: 9999, padding: "12px 28px", fontSize: 14,
              fontWeight: 600, cursor: "pointer",
            }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
